import { gql } from '@apollo/client';

export default gql`
  query inspectionResult($id: ID!) {
    space {
      adminRole
      inspectorRole
    }
    inspectionResult(id: $id) {
      id
      doneAt
      createdAt
      result
      notes
      complianceRatio
      doneBy {
        id
        name
        surname
        email
      }
      inspectionResultFields {
        id
        inspectionFieldId
        name
        order
        value
      }
      inspection {
        id
        name
        dueDate
        periodCycle
        periodNumber
        place {
          id
          name
          street
          city
          zipCode
        }
        inspectionSubject {
          id
          name
          serialNumber
          brand
          model
        }
      }
    }
  }
`;
